export default __webpack_public_path__ + "static/media/chica_ordenador.2780fb43.svg";